export default __webpack_public_path__ + "static/media/HowToPlayBottomImg.848a6a27.png";